import { Datepicker } from 'vanillajs-datepicker';
import de from 'vanillajs-datepicker/locales/de';
import enGB from 'vanillajs-datepicker/locales/en-GB';
import nl from 'vanillajs-datepicker/locales/nl';

Object.assign(Datepicker.locales, de, enGB, nl);

export default class DatePicker {
    constructor($el) {
        this.$el = $el;

        const language = document.documentElement.lang.split('-')[0];

        this.datepicker = new Datepicker(this.$el, {
            autohide: true,
            clearButton: true,
            container: document.body,
            format: 'dd/mm/yyyy',
            language: language === 'en' ? 'en-GB' : language,
            todayButton: true,
            todayButtonMode: 1,
            todayHighlight: true,
        });
    }
}
